<!-- dm-header -->
<!-- 展示：左侧返回图标、标题、右侧展示可选空、文字按钮、图片按钮-->
<!-- 事件：点击左侧按钮 click-left-btn(可选)，点击右侧按钮 click-right-btn -->
<template>
  <div class="container" v-bind:class="{'container-ios': os=='IOS'}">
    <div class="container-left">
      <!-- <div class="sprite sprite-goback"  v-show="showLeftBtn"></div> -->
    </div>
    <div class="container-center d-text-middle d-text-black">{{title}}</div>
    <div class="container-right">
      <button v-show="showRightBtn && rightBtnType=='text'" class="container-right-text d-text-lightgrey d-text-small"
              v-bind:class="{'d-text-green': !disabledRightBtn}"
              v-bind:disabled="disabledRightBtn" @click="$emit('click-right-btn')">
        {{rightText}}
      </button>
      <div v-show="showRightBtn && rightBtnType=='img'" class="d-no-border sprite sprite-add_rule"
           @click="$emit('click-right-btn')"></div>
    </div>
  </div>
</template>

<script>
  import util from '../global/util';
  export default {
    name: 'dm-header',
    data: () => ({
      os: 'Android'
    }),
    props: {
      'title': { // 居中展示的标题，不可缺省
        type: String,
        required: true
      },
      'hasLeftCallbackFunc': { // 是否传入左侧按钮点击的回调事件,为false时点击左侧按钮退回上一页，为true时应传入click-left-btn函数。
        type: Boolean,
        required: false,
        default: false
      },
      // 'showLeftBtn': { // 控制是否展示右侧按钮，默认不展示
      //   type: Boolean,
      //   required: false,
      //   default: true
      // },
      'showRightBtn': { // 控制是否展示右侧按钮，默认不展示
        type: Boolean,
        required: false,
        default: false
      },
      'rightBtnType': { // 控制右侧按钮类型：'text' || 'img'，设置为text时需传入rightText参数
        type: String,
        required: false,
        default: 'text'
      },
      'rightText': { // 文字按钮展示的内容
        type: String,
        required: false,
        default: ''
      },
      'disabledRightBtn': { // 设置右侧按钮的状态是否可用，默认可用
        type: Boolean,
        required: false,
        default: false
      }
    },
    methods: {
      init() {
        this.os = util.getBrowserEnv();
      },
    },
    mounted() {
      this.init();
    }
  };
</script>

<style scoped>
  .container {
    height: 48px; /*安卓的header高度*/
   /* background: #f1f2f6;*/
    background: #fff;
    border-bottom: 1px solid #ddd;
    padding: 0 15px;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-box;
    display: flexbox;
    display: flex;
    justify-content: space-between;
    align-items: center;
    left: 0;
    right: 0;
    top: 0;
    position: fixed;
  }

  .container-ios {
    height: 44px; /*ios的header高度*/
  }

  .container-left {
    /* width: 56px; */
    flex-grow: 0;
    flex-shrink: 0;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-box;
    display: flexbox;
    display: flex;
    justify-content: flex-start;
  }

  .container-center {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .container-right {
    /* width: 56px; */
    flex-grow: 0;
    flex-shrink: 0;
    display: -webkit-box;
    display: -moz-box;
    display: -ms-box;
    display: flexbox;
    display: flex;
    justify-content: flex-end;
  }

  .container-right-text {
    border: none;
   /* background: #f1f2f6;*/
    background: #fff;
    padding: 0;
  }

  .container-right-text:active {
    color: #09ab66;
  }
</style>


// WEBPACK FOOTER //
// src/components/dm-header.vue